import React, { useState, useEffect } from 'react';
import { useConfig } from './ConfigContext';
import GetAccessToken from './Tokens';
import { useNavigate } from 'react-router-dom';
import './Delete.css';
import axios from 'axios';

const Delete = () => {
    const [groups, setGroups] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [specimens, setSpecimens] = useState([]);
    const [loadingSpecimens, setLoadingSpecimens] = useState(false);
    const [error, setError] = useState('');
    const config = useConfig();
    const navigate = useNavigate();

    const groupServiceUrl = config?.group_service_url;
    const specimenServiceUrl = config?.model_service_url;

    useEffect(() => {
        const fetchGroups = async () => {
            const access_token = await GetAccessToken(config.user_service_url);
            if (!access_token) {
                navigate('/login');
                return;
            }
            try {
                const response = await fetch(`${groupServiceUrl}/public/list?include_description=true`, {
                    headers: {
                        'Authorization': `Bearer ${access_token}`
                    }
                });
                if (response.status === 401) {
                    sessionStorage.removeItem('access_token');
                    fetchGroups(); // retry
                    return;
                }
                const data = await response.json();
                setGroups(data.groups);
            } catch (err) {
                setError('Error fetching groups.');
            }
        };

        if (groupServiceUrl && config) {
            fetchGroups();
        }
    }, [groupServiceUrl, config, navigate]);

    useEffect(() => {
        const fetchSpecimens = async () => {
            if (!selectedGroup) return;
            setLoadingSpecimens(true);
            const access_token = await GetAccessToken(config.user_service_url);
            if (!access_token) {
                navigate('/login');
                return;
            }
            try {
                const response = await fetch(`${groupServiceUrl}/public/specimens?group_id=${selectedGroup.group_id}`, {
                    headers: {
                        'Authorization': `Bearer ${access_token}`
                    }
                });
                if (response.status === 401) {
                    sessionStorage.removeItem('access_token');
                    fetchSpecimens();
                    return;
                }
                if (response.ok) {
                    const data = await response.json();
                    setSpecimens(data.specimens);
                } else {
                    setError('Error fetching specimens.');
                }
            } catch (err) {
                setError('Error fetching specimens.');
            }
            setLoadingSpecimens(false);
        };

        if (selectedGroup && specimenServiceUrl && config) {
            fetchSpecimens();
        }
    }, [selectedGroup, specimenServiceUrl, config, navigate]);

    const handleGroupChange = (e) => {
        const groupId = e.target.value;
        const group = groups.find(g => g.group_id === parseInt(groupId));
        setSelectedGroup(group);
        setSpecimens([]);
    };

    const handleDeleteSpecimen = async (specimen) => {
        const confirmDeletion = window.confirm(`Are you sure you want to delete specimen "${specimen.specimen_name}"?`);
        if (!confirmDeletion) return;

        const access_token = await GetAccessToken(config.user_service_url);
        if (!access_token) {
            navigate('/login');
            return;
        }
        try {
            const response = await axios.delete(`${specimenServiceUrl}/private/specimen?specimen_id=${specimen.specimen_id}`, {
                headers: {
                    'Authorization': `Bearer ${access_token}`
                }
            });
            if (response.status === 200) {
                setSpecimens(specimens.filter(s => s.specimen_id !== specimen.specimen_id));
                alert('Specimen deleted successfully.');
            } else {
                alert('Failed to delete specimen.');
            }
        } catch (error) {
            alert('Error deleting specimen: ' + error.message);
        }
    };

    return (
        <div className="delete-section">
            <h2>Delete Specimens</h2>
            {error && <div style={{ color: 'red' }}>{error}</div>}
            <div className="group-dropdown">
                <label htmlFor="groupSelect">Select Group:</label>
                <select
                    id="groupSelect"
                    onChange={handleGroupChange}
                    value={selectedGroup ? selectedGroup.group_id : ''}>
                    {/* Only show placeholder if no group is selected */}
                    {!selectedGroup && <option value="">-- Select a group --</option>}
                    {groups.map(group => (
                        <option key={group.group_id} value={group.group_id}>
                            {group.group_name}
                        </option>
                    ))}
                </select>
            </div>
            {selectedGroup && (
                <div className="specimen-list">
                    <h3>Specimens in {selectedGroup.group_name}</h3>
                    {loadingSpecimens ? (
                        <p>Loading specimens...</p>
                    ) : specimens.length === 0 ? (
                        <p>No specimens found in this group.</p>
                    ) : (
                        <ul>
                            {specimens.map(specimen => (
                                <li key={specimen.specimen_id} style={{ marginBottom: '10px' }}>
                                    <span>{specimen.specimen_name}</span>
                                    <button
                                        style={{ marginLeft: '10px' }}
                                        onClick={() => handleDeleteSpecimen(specimen)}>
                                        Delete
                                    </button>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            )}
        </div>
    );
};

export default Delete;
